import twoGo from "@assets/images/2go.svg";
import Avatar from "@material-ui/core/Avatar";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import LocalShippingOutlinedIcon from "@material-ui/icons/LocalShippingOutlined";
import moment from "moment-timezone";
import React from "react";

import { DateTime } from "../Date";

const useStyles = makeStyles(
  theme => ({
    avatar: {
      left: -45,
      position: "absolute",
      top: 0
    },
    card: {
      marginBottom: theme.spacing(3),
      marginLeft: theme.spacing(3),
      position: "relative"
    },
    card1: {
      marginBottom: theme.spacing(5),
      marginLeft: theme.spacing(3),
      position: "relative"
    },
    cardContent: {
      "&:last-child": {
        padding: 16
      },
      boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.05)"
    },
    date: {
      color: theme.typography.caption.color
    },
    root: {
      position: "relative"
    },
    title: {
      "& p": {
        fontSize: "14px"
      },
      display: "flex",
      justifyContent: "space-between",
      marginBottom: theme.spacing(),
      paddingLeft: theme.spacing(3),
      textAlign: "right"
    }
  }),
  { name: "TimelineNote" }
);

interface TimelineNoteNationwideProps {
  date: string;
  message: string | null;
  user: any;
  email: string | null;
}

const dateFormat = value => {
  const date = moment(value);
  return date.format("lll");
};

export const TimelineNoteNationwide: React.FC<TimelineNoteNationwideProps> = props => {
  const { date, user, email, message } = props;

  const classes = useStyles(props);

  return (
    <div className={classes.root}>
      {user ? (
        <Avatar
          className={classes.avatar}
          style={{ background: "#FFFFFF", border: "3px solid #6051E3" }}
        >
          <img src={twoGo} width={28} height={12} />
        </Avatar>
      ) : (
        <Avatar className={classes.avatar} style={{ background: "#E8EAEE" }}>
          <LocalShippingOutlinedIcon color="disabled" />
        </Avatar>
      )}
      <div className={classes.title}>
        <Typography>{email || message}</Typography>
        <Typography className={classes.date}>
          <Typography>
            <DateTime date={date} />
          </Typography>
          <Typography>{dateFormat(date)}</Typography>
        </Typography>
      </div>
      {user ? (
        <Card className={classes.card}>
          <CardContent className={classes.cardContent}>
            <Typography
              dangerouslySetInnerHTML={{
                __html: message.replace(/\n/g, "<br />")
              }}
            />
          </CardContent>
        </Card>
      ) : (
        <div className={classes.card1} />
      )}
    </div>
  );
};
TimelineNoteNationwide.displayName = "TimelineNote";
export default TimelineNoteNationwide;
